import ApiRequester from './ApiRequester';

export default class {
  constructor() {
    this.apiUrls = {
      orders: '/orders',
      returnedOrders: '/returned-orders',
      updateOrder: 'returned-orders/update'
    };
    this.lastCall = 0;
    this.currentCall = 0;
    this.rw = null;
    return this;
  }
  orders(payload) {
    const rw = new ApiRequester();
    rw.method = 'get';
    rw.data = payload;
    rw.url = `${this.apiUrls.orders}?page=${payload.page}&start_date=${payload.startDate}&end_date=${payload.endDate}`;
    return rw.submitRequest();
  }

  returnedOrders(payload) {
    const rw = new ApiRequester();
    rw.method = 'get';
    rw.data = payload;
    rw.url = `${this.apiUrls.returnedOrders}?page=${payload.page}&start_date=${payload.startDate}&end_date=${payload.endDate}`;
    return rw.submitRequest();
  }

  orderDetail(payload) {
    const rw = new ApiRequester();
    rw.method = 'get';
    rw.data = payload;
    rw.url = `${this.apiUrls.orders}/${payload.id}`;
    return rw.submitRequest();
  }

  updateOrder(payload) {
    const rw = new ApiRequester();
    rw.method = 'post';
    rw.data = payload;
    rw.url = this.apiUrls.updateOrder
    return rw.submitRequest();
  }
}
